import { Navigate, RouteObject } from '@suntex.core/nav'
import { EntityLevel } from '@suntex.fim/enums'
import { flaggedItems, getFlags } from '@suntex.fim/flags'
import { BadgePage, ContentLibraryPage, FamilyLink } from '@suntex.fim/player'

import AssessmentReportGoalIndex from '../pages/app/AssessmentReportGoalIndex'
import MyAvatar from '../pages/app/MyAvatar'
import MyBadges from '../pages/app/MyBadges'
import MyQuests from '../pages/app/MyQuest'
import { AchievementsPage } from '../pages/app/Player/Achievements'
import { getRankingRoutes } from '../routing/rankingsRoutes'

import { getAssessmentReportRoutes, getCommonRoutes } from './routeHelpers'

export const playerPages: RouteObject[] = [
  {
    path: 'achievements',
    Component: AchievementsPage
  },
  {
    path: 'avatar',
    Component: BadgePage
  },
  {
    path: 'badge',
    Component: BadgePage
  },
  {
    path: 'content-library',
    Component: ContentLibraryPage
  },
  {
    path: 'family-link',
    Component: FamilyLink
  },
  ...flaggedItems(getFlags().player.badges, [
    {
      path: 'my-badges',
      Component: MyBadges
    }
  ]),
  ...flaggedItems(getFlags().player.goals, [
    {
      path: 'my-goals',
      Component: AssessmentReportGoalIndex
    }
  ]),
  ...flaggedItems(getFlags().player.quests, [
    {
      path: 'my-quests',
      Component: MyQuests
    }
  ]),
  {
    path: 'my-avatar',
    Component: MyAvatar
  },
  {
    path: 'reports',
    children: [...getAssessmentReportRoutes(EntityLevel.Player)]
  },
  ...getCommonRoutes(EntityLevel.Player),
  ...getRankingRoutes(EntityLevel.Player),

  // legacy paths
  {
    path: 'my-progress',
    element: <Navigate to="/player/reports/progress" replace />
  },
  {
    path: 'assessment-report',
    children: [...getAssessmentReportRoutes(EntityLevel.Player)]
  }
]
